export function commitPendingTagInput(
  currentValues: readonly string[],
  inputValue: string,
): string[] | undefined {
  const pendingValue = inputValue.trim();
  if (!pendingValue) {
    return undefined;
  }

  return Array.from(new Set([...currentValues, pendingValue]));
}
